import { call, put } from 'redux-saga/effects';
import { Saga } from 'custom-types/saga';

import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import {
  analyticsOverviewTabData,
  analyticsOverviewTabDataError,
} from 'modules/experiments/ducks/actions';
import { ExperimentsAction, OverviewTabExperimentData } from 'modules/experiments/types';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import { fetchExperimentAnalyticsOverviewTab } from 'api/ExperimentsAPI';

type ExperimentAnalyticsSaga = Saga<
  ExperimentsAction<Record<string, unknown>, OverviewTabExperimentData>
>;

type FetchOverviewTabExperimentData = {
  data: {
    experiment: OverviewTabExperimentData;
  };
};

export function* setOverviewTabDataSaga({
  experimentId,
}: ExperimentsAction<{ experimentId: number }>): ExperimentAnalyticsSaga {
  try {
    const {
      data: { experiment },
    }: FetchOverviewTabExperimentData = yield call(
      fetchExperimentAnalyticsOverviewTab,
      experimentId,
    );

    yield put(analyticsOverviewTabData(experiment));
  } catch (error) {
    yield put(analyticsOverviewTabDataError());

    const errorMessage = yield call(
      getExperimentsTranslations,
      'errorMessage.analyticsOverviewTab',
    );

    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'setOverviewTabDataSaga',
          error,
          additional: { experimentId },
        }),
      ) as any,
    );
  }
}
